module.exports = __webpack_public_path__ + "static/media/image4.65e4842b.jpg";